/**
 * Tree context actions **Recreate from Live Data** on snapshot sample / read-only activity nodes.
 *
 * Keep **`false`** until server `SnapshotService.RefreshSampleInSnapshot` / `RefreshActivityInSnapshot` perform real
 * work (today they are no-ops). The handler still calls `POST .../refresh-sample|activity` so flipping this to **`true`**
 * is enough to expose the menu to users with **`DataSnapshot.Update`** (matches API authorization).
 */
export const SHOW_RECREATE_SNAPSHOT_FROM_LIVE_TREE_ACTION = false;
